"use client";
import { useCallback, useState } from "react";
import { LearningAndDevelopmentResponse } from "@onair/repositories";
import Carousel, { CarouselProps } from "./carousel";
import CarouselImageItem from "./carousel-image-item";
import CarouselYTItem from "./carousel-yt-item";
import CarouselVideoItem from "./carousel-video-item";

interface TopCarouselProps {
	data: Exclude<LearningAndDevelopmentResponse["data"], undefined>["carousel"];
	className?: string;
}
const TopCarousel: React.FC<TopCarouselProps> = ({ data, className }) => {
	const [activeIndex, setActiveIndex] = useState(0);

	const handleChangeSlide: Exclude<CarouselProps["onSlideChange"], undefined> =
		useCallback((swiper) => {
			setActiveIndex(swiper.activeIndex);
		}, []);

	if (!data?.length) return null;

	return (
		<div className={className}>
			<Carousel onSlideChange={handleChangeSlide}>
				{data.map((item, _index) =>
					item.type === "IMAGE" ? (
						<CarouselImageItem
							key={_index}
							thumbnailUrl={item.image?.url}
							thumbnailAlt={item.image?.alternativeText}
							title={item.title}
							description={item.description}
							href={item.link}
							isActive={_index === activeIndex}
						/>
					) : item.type === "VIDEO_YT" ? (
						<CarouselYTItem
							key={_index}
							index={_index}
							videoId={item.youtubeVideo}
							href={item.link}
							isActive={_index === activeIndex}
						/>
					) : (
						<CarouselVideoItem
							key={_index}
							videoUrl={item.image?.url}
							href={item.link}
							isActive={_index === activeIndex}
						/>
					),
				)}
			</Carousel>
		</div>
	);
};
export default TopCarousel;
